<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
import { getPopUrlInfo } from "./http/HotLineCall";
import { addInfoTips } from "./http/MsgTips";
import { mapMutations } from 'vuex';
import { getTimes } from "./components/Common/datetime.js";
export default {
  name: 'app',
  data() {
    return {
      openOrderReturnInterval: null,
      iAgCallPID: '', //上一通坐席来电pid，坐席如果电话不接，用这个作为记录id
    }
  },
  created(){
    
  },
  mounted(){
    this.postMessageFn()
    this.checkPageHidden()
  },
  methods: {
    ...mapMutations('navTabs', ['addTab', 'closeTab']),
    postMessageFn(){
      //子系统页面postMessage
      window.addEventListener('message', (e)=>{
        let obj = e.data

        if(obj.message){
          //外呼 格式：top.postMessage({message: 'callout', phone: 'xxxxx', popupType: x, otherParams: ''}, '*')
          if(obj.message.toLocaleLowerCase() == 'callout'){
            if(obj.phone){
              let agpBox = document.getElementById('agpBox')
              if(agpBox.contentWindow.document.getElementById('btn_call').clientHeight > 0){
                //判断agp的呼出按钮是否处于可呼出状态
                if(obj.noComfir){ //判断是否需要弹出确认框，在弹窗里呼叫会有遮盖层关不掉的bug
                  agpBox.contentWindow.phonenumSetFn(obj.phone, true) //重设agp外呼客户号码
                  agpBox.contentWindow.callOutFn(obj.popupType?obj.popupType:null) //调用外呼
                  if(obj.otherParams){
                    //有额外传递的参数，这些参数需要在弹屏时发送给弹屏页面 - 记录下来
                    this.$store.state.navTabs.otherParams = obj.otherParams
                  }
                }else{
                  this.$confirm('是否确定要外呼' + obj.phone, '注意', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                  }).then(() => {
                    agpBox.contentWindow.phonenumSetFn(obj.phone, true) //重设agp外呼客户号码
                    agpBox.contentWindow.callOutFn(obj.popupType?obj.popupType:null) //调用外呼
                    if(obj.otherParams){
                      //有额外传递的参数，这些参数需要在弹屏时发送给弹屏页面 - 记录下来
                      this.$store.state.navTabs.otherParams = obj.otherParams
                    }
                  }).catch()
                }
              }else{
                this.$Msg.error('未登录AGP或外呼状态不正确')
              }
            }else{
              this.$Msg.error('没有可呼叫的号码')
            }
          }

          //邮件 格式：top.postMessage({message: 'sendemail', email: 'xxx@xxx' }, '*')
          if(obj.message.toLocaleLowerCase() == 'sendemail'){
            if(obj.email){
              let menuList = this.$store.state.navTabs.menuList
              let item = this.getMenuItem(menuList, 'Email/EmailCreate')
              if(item){
                this.addTab(item)
                setTimeout(()=>{
                  this.$store.state.navTabs.emailAddress = obj.email
                },500)
              }
            }else{
              this.$Msg.error('没有收件地址')
            }
          }

          //短信 多个手机号使用逗号隔开 格式：top.postMessage({message: 'sendsms', phone: 'xxxxxxx' }, '*')
          if(obj.message.toLocaleLowerCase() == 'sendsms'){
            if(obj.phone){
              this.$store.state.navTabs.smsPhoneNum = obj.phone //直接把短信的接收号码传到全局组件
            }else{
              this.$Msg.error('没有接收短信号码')
            }
          }

          //打开tab 格式：top.postMessage({message: 'opentab', webUrl: 'xxxxx', menuName: 'xxxx', otherData: ''}, '*')
          if(obj.message.toLocaleLowerCase() == 'opentab'){
            let item = { webUrl: '', menuId: '', menuName: '' }
            //子系统打开tab有三种情况
            if(obj.webUrl){
              //打开外部链接，带http://或https://
              //打开未配置菜单的内部组件，views文件夹相对路径，例如 Home/Home
              item.webUrl = obj.webUrl
              item.menuId = obj.menuName
              item.menuName = obj.menuName
            }else{
              //打开已配置菜单的内部组件
              let menuList = this.$store.state.navTabs.menuList
              item = this.getMenuItem(menuList, obj.menuName)
            }
            if(item){
              this.addTab(item)
            }else{
              this.$Msg.error('没有找到可打开的页面')
            }
          }

          //关闭来电提示 closeCallTip
          if(obj.message.toLocaleLowerCase() == 'closecalltip'){
            this.$store.state.navTabs.comePhoneTip = '';
          }

          //关闭tab 格式：top.postMessage({message: 'closetab', menuName: 'xxxx'}, '*')
          if(obj.message.toLocaleLowerCase() == 'closetab'){
            if(obj.menuName){
              //关闭指定页面
              this.closeTab(obj.menuName)
            }else{
              //没传指定页面默认关闭当前页
              this.closeTab(this.$store.state.navTabs.activeTabName)
            }
          }

          //桌面通知
          //top.postMessage({message: 'msg', text: '', head: '', isAddTip: true})
          //top.postMessage({message: 'createwebtips', text: '', head: ''})
          if(obj.message.toLocaleLowerCase() == 'msg' || obj.message.toLocaleLowerCase() == 'createwebtips'){
            let head = obj.head?obj.head:'消息';
            let text = obj.text?obj.text:obj.msg?obj.msg:'';
            this.createWebTips(text, head, 1);
          }

          //桌面通知 - 记录到我的通知数据库
          //top.postMessage({message: 'addmsg', title: '', content: '', recId: ''})
          if(obj.message.toLocaleLowerCase() == 'addmsg'){
            this.addInfoTipsFn(obj.title, obj.content, obj.recId);
          }

          //接收工单系统弹屏页面通知进行相关工单信息保存
          //格式 top.postMessage({message: 'workorder', pid: 'xxxx', name: 'xxxx', orderId: 'xxxxx', userId: 'xxxx', originType: 'CALLCENTER'}, '*')
          if(obj.message.toLocaleLowerCase() == 'workorder'){
            let orderId = obj.orderId
            let name = obj.name
            let pid = obj.pid
            let userId = obj.userId
            let originType = obj.originType
            this.$store.state.navTabs.activeTabName = '888'
            this.$nextTick(()=>{
              this.$store.state.navTabs.cusOrderData = {
                orderId: orderId,
                cusName: name,
                cusId: userId,
                sessionId: pid,
                originType: originType
              }
            })
          }

          //接收工单系统通知关闭指定的今日通话 格式 top.postMessage({message: 'workorderclose'}, '*')
          if(obj.message.toLocaleLowerCase() == 'workorderclose'){
            this.$store.state.navTabs.workorderclose = true //触发关闭当前工单的变量值
          }

          //打开来电弹屏 //格式 top.postMessage({message: 'openorder',strCaller: '',strCalled: '',iPopupType: '',iBaseCallPID: '',iAgCallPID: '',iBusiPID: '',iPrivateInfo: '', autoAnswer: '1'}, '*')
          /**
           * strCaller 主叫号
           * strCalled 被叫号
           * iPopupType 弹屏类型 1=来电弹屏,2=自动外呼(OBS)弹屏,3=呼叫外线,4=未接电话回访,5=坐席流失电话回访,6=ACD流失电话回访,7=留言电话回访,其他数字是自定义
           * iBaseCallPID 基础PID
           * iAgCallPID 坐席通话PID
           * iBusiPID 业务PID
           * iPrivateInfo 私有数据
           */
          if(obj.message.toLocaleLowerCase() == 'openorder'){
            //拼接平台发送过来的数据结构
            this.$nextTick(()=>{
              this.iAgCallPID = obj.iAgCallPID;

              let callPopData = {
                strCaller: obj.strCaller,
                strCalled: obj.strCalled,
                iPopupType: obj.iPopupType,
                iBaseCallPID: obj.iBaseCallPID,
                iAgCallPID: obj.iAgCallPID,
                iBusiPID: obj.iBusiPID,
                iPrivateInfo: obj.iPrivateInfo,
                autoAnswer: obj.autoAnswer
              }
              if(obj.isClose){
                callPopData.isClose = true //有传参直接进来的电话就是挂断状态
              }
              this.getPopUrlInfoFn(callPopData, (json)=>{
                json.autoAnswer = obj.autoAnswer;
                //来电时打开一个提示用的信息窗口
                if(obj.iPopupType==1){
                  json.callOfferedType = obj.callOfferedType;
                  this.$store.state.navTabs.comePhoneTip = json;
                }
                //根据弹屏链接的打开方式使用对应的方式
                if(json.showType == 1){
                  //页面新的标签页打开弹屏
                  let times = new Date().getTime()
                  let timesStr = getTimes(times, 'yyyy-MM-dd HH:mm:ss')
                  let item = { webUrl: json.openUrl, menuId: times, menuName: '' }
                  item.menuName = (obj.iPopupType==1?'呼入-':'呼出-') + json.tel + '-' + timesStr //加入呼入呼出时间，短时间内相同号码打进来一样也要弹多个屏
                  this.addTab(item)
                }else if(json.showType == 2){
                  //页面弹窗打开弹屏
                  this.$store.state.navTabs.callPopDataDialog = json
                }else if(json.showType == 3){
                  //不打开
                  return false
                }else{
                  //电话热线标签页打开弹屏 - 默认
                  this.$store.state.navTabs.activeTabName = '888'
                  this.$store.state.navTabs.callPopData = json
                }
              })
            })
          }

          //接收来自子系统的单点登录信息 //格式top.postMessage({message: 'isToken', host: ''}, '*')
          if(obj.message.toLocaleLowerCase() == 'istoken'){
            let tokenArr = []
            if(SessionStorage.getItem('isToken')){
              tokenArr = JSON.parse(SessionStorage.getItem('isToken'))
            }
            tokenArr.push(obj.host)
            tokenArr = this.distinctFn(tokenArr)
            //以数组格式的字符串保存到缓存里，当iframe打开子系统时，检查子系统是否已经存在token，没token去进行单点登录，有token直接进入页面
            SessionStorage.setItem('isToken', JSON.stringify(tokenArr))
          }

          //接收视频客服发送的响铃信息 //格式top.postMessage({message: 'videoring', play: true}, '*')
          if(obj.message.toLocaleLowerCase() == 'videoring'){
            if(obj.play){
              $('#videoRing')[0].play() //响铃
            }else{
              $('#videoRing')[0].pause() //停止
            }
          }

          //线上客户新访客消息 //格式top.postMessage({message: 'newVisitor'}, '*')
          if(obj.message.toLocaleLowerCase() == 'newvisitor') {
            $('#newVisitorAudio')[0].play()
          }

          //问卷提交后对呼叫列表进行刷新操作，兼容外部页面
          if(obj.message.toLocaleLowerCase() == 'refreshlist'){
            //通过jq操作页面结构，连通已打开但不显示的页面也一并刷新列表数据 - 需要预先埋下class名
            let len = document.getElementsByClassName('isRefreshBtn').length
            for(var i = 0; i < len; i++){
              document.getElementsByClassName('isRefreshBtn')[i].click()
            }
            if(obj.tipsType == '0'){
              //默认提示类型，尝试关闭弹窗
              this.$store.state.navTabs.callPopDataDialog = ''
            }
          }

          //新版chrome安全策略iframe链条只要包含第三方源，后续的子iframe也会当作第三方源，不再共用缓存，导致多重iframe下缓存无效
          //通过父子系统通讯，把父系统缓存发送到子系统，再中转给孙子系统
          //top.postMessage({message: 'getsysstorage', localKeys: 'xxxx,xxxxx', sessionKeys: 'xxxx,xxxxx'}, '*')
          if(obj.message.toLocaleLowerCase() == 'getsysstorage'){
            //本地缓存
            let _localStorage = window.localStorage;
            let sendLocal = '';
            if(_localStorage && _localStorage.length && obj.localKeys){
              _localStorage = {
                ..._localStorage
              }
              let sendData = {};
              let localKeys = obj.localKeys.split(','); //根据传进来需要的缓存key返回
              for(let i = 0; i < localKeys.length; i++){
                for(let key in _localStorage){
                  if(key == (localKeys[i] + '_' + window.APIURL.projectName)){
                    sendData[key] = _localStorage[key]
                  }
                }
              }
              sendLocal = JSON.stringify(sendData)
            }
            //临时缓存
            let _sessionStorage = window.sessionStorage;
            let sendSession = '';
            if(_sessionStorage && _sessionStorage.length && obj.sessionKeys){
              _sessionStorage = {
                ..._sessionStorage
              }
              let sendData = {};
              let sessionKeys = obj.sessionKeys.split(','); //根据传进来需要的缓存key返回
              for(let i = 0; i < sessionKeys.length; i++){
                for(let key in _sessionStorage){
                  if(key == (sessionKeys[i] + '_' + window.APIURL.projectName)){
                    sendData[key] = _sessionStorage[key]
                  }
                }
              }
              sendSession = JSON.stringify(sendData)
            }
            //把本地缓存和临时缓存往子系统发送
            if(sendLocal || sendSession){
              let iframes = document.querySelectorAll('iframe');
              for(let i = 0; i < iframes.length; i++){
                iframes[i].contentWindow.postMessage({message: 'syslocalstorage', localStorage: sendLocal, sessionStorage: sendSession}, '*')
              }
            }
          }
          if(obj.message.toLocaleLowerCase() == 'setsysstorage'){
            //接收到设置缓存的请求
            let sendLocal = obj.localStorage;
            if(sendLocal){
              sendLocal = JSON.parse(sendLocal);
              for(let key in sendLocal){
                localStorage.setItem(key, sendLocal[key]);
              }
            }
            let sendSession = obj.sessionStorage;
            if(sendSession){
              sendSession = JSON.parse(sendSession);
              for(let key in sendSession){
                sessionStorage.setItem(key, sendSession[key]);
              }
            }
          }
        }

        //在线发送到父系统的信息 top.postMessage({type: 'agentnum', value: ''}, '*')
        if(obj.type){
          if(obj.type.toLocaleLowerCase() == 'agentnum'){
            //在线排队数量
            this.$store.state.navTabs.onLineNum = obj.value
          }

          //助手监控传递过来的参数
          if(obj.type.toLocaleLowerCase() == 'monitorrequest'){
            //格式如下
            /**var data = {
              type : 'MonitorRequest',
              value : {
                requestType: 1,//请求类型 1.监听 2.强插 3.拦截
                agentId: this.phoneCheckData.agentId || '',
                workNo: this.phoneCheckData.workNo || ''
              }
            };**/
            let requestType = obj.value.requestType;
            let workno = obj.value.workNo;
            let agentid = obj.value.agentId;
            let phone = obj.value.phone;
            let agpBox = document.getElementById('agpBox')
            if(requestType && agpBox.contentWindow.g_Socket4AGP){
              if(requestType == 1){//监听
                agpBox.contentWindow.$Send.ForcenIspection(workno)
              }
              if(requestType == 2){//强插
                agpBox.contentWindow.$Send.ForceInsert(workno)
              }
              if(requestType == 3){//拦截
                agpBox.contentWindow.$Send.ForceIntercept(parseInt(agentid))
              }
              if(requestType == 4){//拨打电话
                if(phone){
                  this.$confirm('是否确定要外呼' + phone, '注意', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                  }).then(() => {
                    agpBox.contentWindow.phonenumSetFn(phone, true) //重设agp外呼客户号码
                    agpBox.contentWindow.callOutFn() //调用外呼
                  }).catch()
                }
              }
            }
          }

          //线上客服有消息时标题闪烁 top.postMessage({type: 'remind'}, '*')
          if (obj.type == 'remind'){
            this.titleSF()
            if(!this.GLOBAL.TIME_1){
              this.bowserTitleSF()
            }
          }
        }

      })
    },
    distinctFn(arr) {
			var i, j,
				len = arr.length;
			for (i = 0; i < len; i++) {
				for (j = i + 1; j < len; j++) {
					if (arr[i] == arr[j]) {
						arr.splice(j, 1);
						len--;
						j--;
					}
				}
			}
			return arr;
		},
    checkViewName() {
      let result = false
      this.$store.state.navTabs.tabList.map(item => {
        if (item.viewName == 'OrderReturn') result = true
      })
      return result
    },
    //检查网站页面是否处于激活状态
    checkPageHidden(){
      var hiddenProperty = 'hidden' in document ? 'hidden' :    
          'webkitHidden' in document ? 'webkitHidden' :    
          'mozHidden' in document ? 'mozHidden' :    
          null;
      var visibilityChangeEvent = hiddenProperty.replace(/hidden/i, 'visibilitychange');
      var onVisibilityChange = ()=>{
          if (!document[hiddenProperty]) {
            this.GLOBAL.FOCUSPAGE = 1 //激活
          }else{
            this.GLOBAL.FOCUSPAGE = 2 //未激活
          }
      }
      document.addEventListener(visibilityChangeEvent, onVisibilityChange);
    },
    //获取弹屏页面地址
    getPopUrlInfoFn(obj, callback){
      let _t = JSON.parse(LocalStorage.getItem("obj"))
      let data = {
        vdnId: _t.vdnId,
        popupType: obj.iPopupType
      }
      getPopUrlInfo(data).then(res => {
        if(res && res.retCode == 1){
          let json = {
            pId: obj.iAgCallPID,
            tel: obj.iPopupType==1?obj.strCaller:obj.strCalled,
            cusName: '',
            cusId: '',
            beginTime: getTimes(new Date().getTime(), 'yyyy-MM-dd HH:mm:ss'),
            second: 0,
            callDirection: obj.iPopupType==1?1:2, //1呼入，2呼出
            isClose: obj.isClose?true:false, //是否挂断
            openUrl: '',
            showType: '2'
          }
          let paramName4VdnId = 'vdnId'
          let paramName4WorkNo = 'workNo'
          let paramName4AgTelNo = 'agTelNo'
          let paramName4Caller = 'caller'
          let paramName4Called = 'tel'
          let paramName4BaseCallPid = 'baseCallPid'
          let paramName4AgCallPid = 'pId'
          let paramName4BusiPid = 'busiPid'
          let paramType4private = ''
          let paramName4private = ''
          let paramValue4private = ''
          if(res.data){
            //有配置弹屏
            let _d = res.data
            json.openUrl = _d.openUrl
            json.showType = _d.showType //弹屏打开方式
            //参数key替换
            paramName4VdnId = _d.paramName4VdnId
            paramName4WorkNo = _d.paramName4WorkNo
            paramName4AgTelNo = _d.paramName4AgTelNo
            paramName4Caller = _d.paramName4Caller
            paramName4Called = _d.paramName4Called
            paramName4BaseCallPid = _d.paramName4BaseCallPid
            paramName4AgCallPid = _d.paramName4AgCallPid
            paramName4BusiPid = _d.paramName4BusiPid
            paramType4private = _d.paramType4private
            paramName4private = _d.paramName4private
            paramValue4private = _d.paramValue4private
          }else if(obj.iPopupType != 1){
            //没有配置弹屏地址的话，使用默认地址 - 来电忽略
            json.openUrl = location.origin + location.pathname + '#/defaultPage?sourceType=1'
          }
          //根据返回的参数拼接弹屏URL
          let pStr = ''
          if(json.openUrl){
            if(paramName4VdnId){ //vdn
              pStr += '&' + paramName4VdnId + '=' + _t.vdnId
            }
            if(paramName4WorkNo){ //工号
              pStr += '&' + paramName4WorkNo + '=' + _t.workNo
            }
            if(paramName4AgTelNo){ //分机号
              pStr += '&' + paramName4AgTelNo + '=' + _t.extNum
            }
            if(paramName4Caller){ //主叫号
              pStr += '&' + paramName4Caller + '=' + obj.strCaller
            }
            if(paramName4Called){ //被叫号
              pStr += '&' + paramName4Called + '=' + obj.strCalled
            }
            if(paramName4BaseCallPid){ //主PID
              pStr += '&' + paramName4BaseCallPid + '=' + obj.iBaseCallPID
            }
            if(paramName4AgCallPid){ //子PID
              pStr += '&' + paramName4AgCallPid + '=' + obj.iAgCallPID
            }
            if(paramName4BusiPid){ //业务PID
              pStr += '&' + paramName4BusiPid + '=' + obj.iBusiPID
            }
            pStr += '&popupType=' + obj.iPopupType
            //私有数据 - 不为空
            if(paramType4private && paramType4private!='0'){
              if(paramName4private){ //有配置参数名
                if(paramType4private == '1'){ //固定值
                  pStr += '&' + paramName4private + '=' + paramValue4private
                }else if(paramType4private == '2'){ //JSON格式
                  pStr += '&' + paramName4private + '=' + obj.iPrivateInfo
                }
              }
            }
            if(pStr.indexOf('qsPage') > -1 && pStr.indexOf('&sourceType') == -1){
              //如果配置的是问卷页面，增加参数sourceType=1
              pStr += '$sourceType=1'
            }
            //拼接参数
            if(json.openUrl.indexOf('?') > -1){
              json.openUrl = json.openUrl + pStr
            }else{
              pStr = pStr.substring(1)
              json.openUrl = json.openUrl + '?' + pStr
            }
            if(this.$store.state.navTabs.otherParams){
              //有额外参数时，把额外参数也加到弹屏页面地址里
              let otherParams = JSON.parse(this.$store.state.navTabs.otherParams)
              let opStr = ''
              for(var item in otherParams){
                opStr += '&' + item + '=' + otherParams[item]
              }
              json.openUrl = json.openUrl + opStr
              this.$store.state.navTabs.otherParams = null //使用一次后清空
            }
          }

          if(callback){
            callback(json)
          }
        }
      })
    },
    //记录提示数据
    addInfoTipsFn(title, content, recId){
      let _t = JSON.parse(LocalStorage.getItem('obj'));
      let data = {
        vdnId: _t.vdnId,
        userId: _t.userId,
        msgTypeId: '1',
        title: title,
        content: content,
        relationRecId: recId?recId:this.iAgCallPID,
        viewColor: 'red'
      }
      addInfoTips(data);
    },
  }
}
</script>

<style>
*{
  padding:0;
  margin:0;
}
.el-tabs--border-card>.el-tabs__content{
  padding:0 !important;
  height: calc(100% - 39px);
}
html,body,#app{
 height: 100%;
}
html,body{
  overflow: hidden;
}
.el-table th>.cell{
  color:#353A42;
}

.el-main{
	/* z-index: 10; */
	width:85%;
}
button {
  cursor: pointer;  
}
.el-table-column--selection .cell{
  padding-left: 10px;
  padding-right: 10px;
}
</style>



// WEBPACK FOOTER //
// App.vue?5171b422